import { useCallback, useEffect, useState } from "react";
import { fetchActionsUtil, useCookie } from "../../utils";
import { URLS } from "../urls";

export const SideBarDropDownItems = () => {
  const user_Id = useCookie("userId");

  const [token, setToken] = useState("");
  const [isLineManager, setIsLineManager] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      const result = await fetchActionsUtil(
        `${URLS.backendUsers}/get-attendance-generated-token?userId=${user_Id}`
      );
      setToken(result?.token);
      setIsLineManager(result?.isLineManager);
    } catch (error) {
      console.log({ error });
    } finally {
    }
  }, [user_Id]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchData();
    }
    return () => {
      isMounted = false;
    };
  }, [fetchData]);

  const menu = [
    {
      name: "Dashboard",
      icon: <i className="la la-dashboard"></i>,
      link: URLS.dashboard, // (submenuName or link or url) These are the three options(if it has submenuName, it must have children)
    },
    {
      name: "My Profile",
      icon: <i className="fa fa-user-circle-o"></i>,
      link: `/dashboard/profile/${user_Id}`,
    },
    {
      name: "Employees",
      icon: <i className="la la-user"></i>,
      submenuName: "employee",
      children: [
        { name: "All Employees", link: "/dashboard/employees" },
        { name: "Leaves (Admin)", link: "/dashboard/leaves" },
        { name: "Leave Settings", link: "/dashboard/leaveSettings" },
        { name: "My Leave", link: URLS.myLeave },
        { name: "Employee Category", link: URLS.jobCategory },
        { name: "Departments", link: "/dashboard/departments" },
        { name: "Promotion", link: "/dashboard/promotion" },
        { name: "Suspension", link: "/dashboard/suspension" },
        { name: "Resignation", link: "/dashboard/resignation" },
        { name: "Termination", link: "/dashboard/termination" },
        { name: "Abandonment", link: URLS.abandonment },
        { name: "Roster Planning", link: URLS.rosterPlanning },
        { name: "Loans", link: "/dashboard/loan" },
      ],
    },
    {
      name: "Payroll",
      icon: <i className="la la-money"></i>,
      submenuName: "payroll",
      children: [
        { name: "Process Payroll", link: "/dashboard/process-payroll" },
        {
          name: "RemunerationMenu",
          details: [
            {
              mainSettingsName: "deductionSettings",
              name: "Deductions",
              smallState: "deductionSmall",
              mainIndex: "deductionIndex",
              settingLevelOne: "payrollLevelOne",
              linkName: "deduction-settings",
              showStatic: true,
            },
            {
              mainSettingsName: "bonusSettings",
              name: "Bonus",
              smallState: "bonusSmall",
              mainIndex: "bonusIndex",
              settingLevelOne: "bonus",
              linkName: "bonus-settings",
              showStatic: false,
            },
            {
              mainSettingsName: "allowance",
              name: "Allowance",
              smallState: "allowanceSmall",
              mainIndex: "allowanceIndex",
              settingLevelOne: "allowance",
              linkName: "allowance",
              showStatic: false,
            },
            {
              mainSettingsName: "benefit",
              name: "Benefits",
              smallState: "benefitSmall",
              mainIndex: "benefitIndex",
              settingLevelOne: "benefit",
              linkName: "benefit",
              showStatic: false,
            },
          ],
        },
        { name: "Job Grade", link: "/dashboard/job-grade" },
        { name: "Change Job Grade", link: "/dashboard/change-job-grade" },
        {
          name: "Allowance Application",
          link: "/dashboard/allowance-application",
        },
        {
          name: "Full And Final",
          link: URLS.fullAndFinally,
        },
        {
          insideChildren: {
            name: "Reports",
            submenuName: "settingsReports",
            children: [
              { name: "Salary Schedule", link: "/dashboard/salary-summary" },
              { name: "Payroll History", link: "/dashboard/pay-history" },
              {
                name: "Deduction Reports",
                link: "/dashboard/deduction-reports",
              },
              { name: "Bonus Reports", link: "/dashboard/bonus-reports" },
              {
                name: "Allowance Reports",
                link: "/dashboard/allowance-reports",
              },
              { name: "Benefit Reports", link: "/dashboard/benefit-reports" },
              { name: "Attendance Reports", link: URLS.attendanceReport },
            ],
          },
        },
        {
          name: "Custom Reports",
          link: URLS.customReport,
        },
        { name: "Application Settings", link: "/dashboard/pay-settings" },
      ],
    },
    {
      name: "Clients",
      icon: <i className="la la-users"></i>,
      link: "/dashboard/clients",
    },
    {
      name: "Contracts",
      icon: <i className="la la-briefcase"></i>,
      link: "/dashboard/contracts",
    },
    {
      name: "Time Sheet",
      icon: <i className="la la-clock-o"></i>,
      link: "/dashboard/timesheet",
    },
    {
      name: "My Attendance",
      icon: <i className="fa fa-calendar-check-o"></i>,
      link: URLS.myAttendance,
    },
    {
      name: "Attendance",
      icon: <i className="fa fa-calendar"></i>,
      link: "/dashboard/attendance",
    },
    {
      name: "Take Attendance ",
      icon: <i className="fa fa-address-book"></i>,
      url: `${URLS.takeAttendance}?token=${token}`,
    },
    {
      name: (
        <>
          Permission /<br /> Holiday
        </>
      ),
      icon: <i className="la la-check-square-o"></i>,
      link: URLS.permmission,
    },
    isLineManager && {
      name: "Direct Report",
      icon: <i className="fa fa-users"></i>,
      link: URLS.employeesDirectReports,
    },
    {
      name: "Day Off",
      icon: <i className="fa fa-id-badge"></i>,
      link: URLS.dayOff,
    },
    {
      name: "Forms/Approval",
      icon: <i className="fa fa-book"></i>,
      url: `${URLS.mainSite}/requisition/request`,
    },
    {
      name: (
        <>
          Jobs <br /> Vacancy
        </>
      ),
      icon: <i className="la la-building"></i>,
      submenuName: "jobs",
      children: [{ name: "Manage Jobs", link: "/dashboard/jobs" }],
    },
    {
      name: "Performance",
      icon: <i className="fa fa-bullseye"></i>,
      link: "/dashboard/performance",
    },
    {
      name: "Policies",
      icon: <i className="la la-file-pdf-o"></i>,
      link: "/dashboard/policies",
    },
    {
      name: (
        <>
          Application <br /> Settings
        </>
      ),
      icon: <i className="fa fa-cogs"></i>,
      link: "/dashboard/pay-settings",
    },
  ].filter(Boolean);

  return menu;
};
